import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as ArchiveSvg } from '../../assets/archive-icon.svg';

export const ArchiveIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={ArchiveSvg} {...props} />;
};
